import styled from 'styled-components';

export const FilterTagsContainer = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;

  & > .hefesto-chip > * .mdc-chip {
    background-color: ${({ theme }) => theme.colors.blue8};
    color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.blue8};
    max-width: 15rem;
    & > .mdc-chip__text {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & > * svg {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const FiltersContainer = styled.div``;

export const FilterTitle = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.grayDark3};
  margin-top: 12px;
  margin-bottom: 12px;
  height: 24px;
  display: flex;
  box-sizing: border-box;
`;

export const FilterHeader = styled.div`
  margin-bottom: 1.25rem;
`;

export const ClearAllButtonContainer = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    height: 48px;
  }
`;

export const FilterContainer = styled.div`
  /* margin-top: 1.5rem; */
`;

export const CheckboxContainer = styled.div`
  padding: 0.75rem 1rem;
  max-height: 48px;
  .hefesto-checkbox {
    margin: 0;
    height: 24px;
    gap: 0.75rem;
  }
  .hefesto-checkbox__label {
    color: #414e55;
  }
  input[type='checkbox'] {
    transform: scale(1.8) !important;
  }
`;
